export const T = {
  en_GB: {
    title: (name: string) => `Move clients from ${name}`,
    description: (name: string) =>
      `All clients owned by ${name} get the new owner. Private clients follow their owner.`,
    newOwner: "New owner",
    choose: "Choose a user",
    search: "Search users...",
    unnamedUser: "Unnamed user",
    noUsers: "No other active users",
    noResults: "No users found",
    move: "Move clients",
    cancel: "Cancel",
    moved: (n: string) => `${n} clients moved`,
    invalidOwner: "Choose an active user",
    failed: "Failed to move clients",
  },
  nb_NO: {
    title: (name: string) => `Flytt kunder fra ${name}`,
    description: (name: string) =>
      `Alle kunder som eies av ${name} får ny eier. Private kunder følger eieren.`,
    newOwner: "Ny eier",
    choose: "Velg en bruker",
    search: "Søk etter brukere...",
    unnamedUser: "Bruker uten navn",
    noUsers: "Ingen andre aktive brukere",
    noResults: "Ingen brukere funnet",
    move: "Flytt kunder",
    cancel: "Avbryt",
    moved: (n: string) => `${n} kunder flyttet`,
    invalidOwner: "Velg en aktiv bruker",
    failed: "Kunne ikke flytte kunder",
  },
} as const;
